import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconPlay from 'components/icons/IconPlay';
const VideoPlayIconWrapper = t0 => {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("[background:none] border-0 items-center justify-start bottom-0 top-20 flex flex-col left-0 absolute right-0 z-[1]", "hover:cursor-pointer", "[&_svg]:min-w-[70px] [&_svg]:w-[50px] [&_svg]:h-[50px]\"");
    t2 = <IconPlay width="14%" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <button type="button" onClick={onClick} className={t1}>{t2}</button>;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
VideoPlayIconWrapper.propTypes = {
  onClick: PropTypes.func
};
export default VideoPlayIconWrapper;